(function() {
  'use strict';

  var ACTION = { ALLOW: 'ALLOW', BLOCK: 'BLOCK' };
  var RESTRICTION_FLAG = 'purchaseRestricted';
  var BUY_BUTTON_SELECTOR =
    'button[name="add"], ' +
    '.shopify-payment-button__button, ' +
    '.product__submit, ' +
    '.product__sticky-atc-button, ' +
    '.product-form-sticky__add-button, ' +
    '.product-form__buttons button, ' +
    '.product-form button[type="submit"]';

  // ---------------------------------------------------------------------------
  // Region registry — single definition of all geographic groups
  // ---------------------------------------------------------------------------
  var REGIONS = {
    approved: ['US', 'CA'],
    eu: [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
      'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LI', 'LT', 'LU',
      'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
    ]
  };

  function inRegion(country, region) {
    return REGIONS[region].indexOf(country) !== -1;
  }

  // ---------------------------------------------------------------------------
  // Layer 1 — Country (deterministic: Shopify market country only)
  // ---------------------------------------------------------------------------
  function getCountry() {
    var code = document.body.dataset.shopifyCountry;
    return code ? code.toUpperCase() : null;
  }

  // ---------------------------------------------------------------------------
  // Layer 2 — Product classification (server-defined via theme.liquid)
  // ---------------------------------------------------------------------------
  function getProductContext() {
    return {
      purchasePolicy: document.body.dataset.purchasePolicy || null
    };
  }

  // ---------------------------------------------------------------------------
  // Layer 3 — Policy engine
  // Output: { action: ALLOW|BLOCK, reason: string|null, ruleId: string|null }
  // Lower priority number = evaluated first. First matching rule wins.
  // ---------------------------------------------------------------------------
  var RULES = [
    {
      priority: 10,
      id: 'global_eu_block',
      reason: 'Not available in your region',
      test: function(ctx) {
        return !!ctx.country && inRegion(ctx.country, 'eu');
      }
    },
    {
      priority: 20,
      id: 'product_us_canada_only',
      reason: 'This product is not available in your region.',
      test: function(ctx) {
        return (
          ctx.product.purchasePolicy === 'us-canada-only' &&
          !!ctx.country &&
          !inRegion(ctx.country, 'approved')
        );
      }
    }
  ];

  var orderedRules = RULES.slice().sort(function(a, b) {
    return a.priority - b.priority;
  });

  function resolvePolicy() {
    var ctx = {
      country: getCountry(),
      product: getProductContext()
    };

    for (var i = 0; i < orderedRules.length; i++) {
      var rule = orderedRules[i];
      if (rule.test(ctx)) {
        return { action: ACTION.BLOCK, reason: rule.reason, ruleId: rule.id };
      }
    }

    return { action: ACTION.ALLOW, reason: null, ruleId: null };
  }

  function policySignature(policy) {
    return policy.action + ':' + (policy.ruleId || '');
  }

  // ---------------------------------------------------------------------------
  // Layer 4 — UI enforcement
  // ---------------------------------------------------------------------------
  var lastSignature = null;
  var domObserver = null;

  function getBuyButtons() {
    return document.querySelectorAll(BUY_BUTTON_SELECTOR);
  }

  function isSoldOut(btn) {
    var form = btn.closest('form');
    var variantInput = form ? form.querySelector('.product-variant-id') : null;
    return !!(variantInput && variantInput.hasAttribute('disabled'));
  }

  function cacheButtonLabel(btn) {
    if (btn.dataset.purchaseRestrictedLabel) return;

    var labelNode = btn.querySelector('.product-form__submit-button-text, .submit-button__text');
    if (labelNode) {
      btn.dataset.purchaseRestrictedLabel = labelNode.textContent;
      return;
    }

    var trimmed = btn.textContent.trim();
    if (trimmed) {
      btn.dataset.purchaseRestrictedLabel = trimmed;
    }
  }

  function restoreButtonLabel(btn) {
    var original = btn.dataset.purchaseRestrictedLabel;
    if (!original) return;

    var labelNode = btn.querySelector('.product-form__submit-button-text, .submit-button__text');
    if (labelNode) {
      labelNode.textContent = original;
    } else {
      btn.textContent = original;
    }

    delete btn.dataset.purchaseRestrictedLabel;
  }

  function applyBlock(btn, reason) {
    if (btn.dataset[RESTRICTION_FLAG] === 'true' && btn.dataset.purchaseRestrictedReason === reason) {
      return;
    }

    cacheButtonLabel(btn);

    btn.disabled = true;
    btn.style.opacity = '0.4';
    btn.style.pointerEvents = 'none';
    btn.setAttribute('aria-disabled', 'true');
    btn.dataset[RESTRICTION_FLAG] = 'true';
    btn.dataset.purchaseRestrictedReason = reason;
    btn.title = reason;

    var labelNode = btn.querySelector('.product-form__submit-button-text, .submit-button__text');
    if (labelNode) {
      labelNode.textContent = reason;
    } else if (btn.textContent.trim()) {
      btn.textContent = reason;
    }
  }

  function applyAllow(btn) {
    if (btn.dataset[RESTRICTION_FLAG] !== 'true') return;

    restoreButtonLabel(btn);

    var soldOut = isSoldOut(btn);
    btn.disabled = soldOut;
    btn.style.pointerEvents = soldOut ? 'none' : '';
    btn.style.opacity = soldOut ? '0.4' : '';
    if (soldOut) {
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.removeAttribute('aria-disabled');
    }
    btn.style.cursor = '';
    btn.title = '';
    delete btn.dataset[RESTRICTION_FLAG];
    delete btn.dataset.purchaseRestrictedReason;
  }

  function enforcePolicy(policy) {
    var block = policy.action === ACTION.BLOCK;
    var reason = policy.reason || '';

    getBuyButtons().forEach(function(btn) {
      if (block) {
        applyBlock(btn, reason);
      } else {
        applyAllow(btn);
      }
    });
  }

  function syncPurchaseUI(force) {
    var policy = resolvePolicy();
    var signature = policySignature(policy);

    if (!force && signature === lastSignature) {
      if (policy.action === ACTION.BLOCK) {
        enforcePolicy(policy);
      }
      return;
    }

    lastSignature = signature;
    enforcePolicy(policy);
  }

  function observeDomChanges() {
    if (domObserver) return;

    domObserver = new MutationObserver(function() {
      syncPurchaseUI(false);
    });

    var targets = document.querySelectorAll(
      'main, .product-form, .product__form, [data-product-form], .shopify-section'
    );

    if (targets.length === 0) {
      domObserver.observe(document.body, { childList: true, subtree: true });
      return;
    }

    targets.forEach(function(target) {
      domObserver.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'class']
      });
    });
  }

  function init() {
    syncPurchaseUI(true);
    observeDomChanges();
    document.addEventListener('shopify:section:load', function() {
      syncPurchaseUI(true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
